import { createFileRoute } from "@tanstack/react-router"
import { TenantUserManagement } from "./-components/tenant-user-management"

export const Route = createFileRoute(
  "/_layout/settings/system_/tenants/$tenantId/users",
)({
  staticData: { breadcrumb: "Users" },
  component: TenantUsersTab,
})

function TenantUsersTab() {
  const { tenantId } = Route.useParams()
  return <TenantUserManagement tenantId={tenantId} />
}
